<script>
  import Badge from '../Badge.svelte';
  import { scaleOrdinal, scaleThreshold } from 'd3-scale';

  export let value;
  export let minValue = 0;
  export let maxValue = 100;
  export let valueFormat = (v) => `${v.toFixed(1)}%`;

  export let colorScale = scaleOrdinal()
    .domain(['Failing', 'Passing'])
    .range(['#1f2870', '#cccccc']);
  export let threshold = scaleThreshold()
    .domain([14.9999])
    .range(['Failing', 'Passing']);
</script>

<Badge
  bind:value
  bind:minValue
  bind:maxValue
  bind:valueFormat
  bind:colorScale
  bind:threshold
/>
